import {apiRedux} from "../reducers/apiRedux";
import {apiUrls} from "../../constants/appUrls";

const AuthApi = apiRedux.injectEndpoints({
  endpoints: (build) => ({
    authLogout: build.mutation({
      query: (data) => ({
        url: apiUrls.logout,
        method: 'POST',
        body: data,
      }),
    }),


    authLogin: build.mutation({
      query: (data) => ({
        url: apiUrls.login,
        method: 'POST',
        body: data,
      }),
    }),


  })
});

export const {useAuthLoginMutation} = AuthApi;
export const {useAuthLogoutMutation} = AuthApi;
